module.exports = __webpack_public_path__ + "static/media/Ruby.358782ff.png";